// PageDescription: 질환백과 리스트 페이지
import useGetDiagnosisCategories from '@/hooks/telemedicine/useGetDiagnosisCategories';
import { CustomPageProps } from '@/types/app';
import { withClientServerSideProps } from '@/utils/mobile/RNPlugins';
import { DiseaseEncyclopediaView, useDiseaseEncyclopediaViewModel } from '@/views/disease-encyclopedia';
import useGetPopularDiseaseEncyclopedias from '@/views/disease-encyclopedia/segments/hooks/useGetPopularDiseaseEncyclopedias';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const DiseaseEncyclopediaPage = ({ client }: CustomPageProps) => {
  const viewModel = useDiseaseEncyclopediaViewModel({ client });

  return (
    <>
      <NextSeo
        title={'닥터나우 질환백과 - 모든 질병의 증상, 원인, 치료 정보'}
        description={
          '감기부터 대상포진까지 모든 질병의 원인, 증상, 치료법, 주의사항을 닥터나우 질환백과에서 확인해보세요.'
        }
      />
      <DiseaseEncyclopediaView viewModel={viewModel} client={client} />
    </>
  );
};

export default DiseaseEncyclopediaPage;

export const getServerSideProps: GetServerSideProps = withClientServerSideProps(async () => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    useGetPopularDiseaseEncyclopedias.prefetchQuery(queryClient),
    useGetDiagnosisCategories.prefetchQuery(queryClient),
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
});
